import React from 'react'
import { BillboardText, Paragraph, colors } from '@fs/zion-ui'
import { NoticeImportant } from '@fs/zion-icon'

export default function CustomFormError({ message }) {
  return (
    <BillboardText primaryColor={colors.yellow70}>
      <Paragraph size="xs">
        <NoticeImportant size="sm" color={colors.yellow70} />
        {message}
      </Paragraph>
    </BillboardText>
  )
}
